import { render, staticRenderFns } from "./VectorResizeDragHandle.vue?vue&type=template&id=50807391&scoped=true&"
import script from "./VectorResizeDragHandle.vue?vue&type=script&lang=ts&"
export * from "./VectorResizeDragHandle.vue?vue&type=script&lang=ts&"
import style0 from "./VectorResizeDragHandle.vue?vue&type=style&index=0&id=50807391&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50807391",
  null
  
)

export default component.exports